(function () {
  const cfg = window.TRANSLATOR_I18N || { lang: 'en', available: ['en'], base: '/i18n' };
  let dict = {};

  function getKeyPath(obj, path) {
    return path.split('.').reduce((o, k) => (o && k in o) ? o[k] : null, obj);
  }
  function strongify(v) {
    if (v == null) return '';
    return String(v).replace(/\*\*(.+?)\*\*/gs, '<b>$1</b>');
  }
  function processHTML(raw) {
    return strongify(raw);
  }
  // Translate Element. Never pass raw string.
  function translateEl(el) {
    const key = (el.getAttribute('data-i18n') || '').trim();
    if (!key) return;
    const raw = getKeyPath(dict, key);
    if (raw == null) return;
    el.innerHTML = processHTML(raw); // <-- apply here
  }

  function applyI18N() {
    document.querySelectorAll('[data-i18n]').forEach(el => {
      const key = el.getAttribute('data-i18n');
      const html = getKeyPath(dict, key);
      if (html != null) el.innerHTML = processHTML(html);
    });
    document.documentElement.setAttribute('lang', cfg.lang);
    markActiveLang(cfg.lang);
  }

  function markActiveLang(lang) {
    document.querySelectorAll('.lang-switch .lang').forEach(btn => {
      const active = btn.dataset.lang === lang;
      btn.classList.toggle('is-active', active);
      if (active) btn.setAttribute('aria-current', 'true');
      else btn.removeAttribute('aria-current');
    });
  }

  function load(lang) {
    const url = `${cfg.base}/${lang}.json`;
    return fetch(url, { cache: 'no-store' })
      .then(r => {
        if (!r.ok) throw new Error(`HTTP ${r.status} fetching ${url}`);
        return r.json();
      })
      .then(data => {
        dict = data;
        cfg.lang = lang;
        localStorage.setItem('lang', lang);
        document.cookie = `lang=${lang};path=/;max-age=${365 * 24 * 60 * 60}`;
        applyI18N();
      })
      .catch(err => console.error('[translator] load failed:', err));
  }

  // Click handler for buttons
  document.addEventListener('click', (e) => {
    console.log('Click Registered from i18n.js');
    const btn = e.target.closest('.lang-switch .lang');
    if (!btn) return;
    console.log('Language switch initiated');
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    const lang = btn.dataset.lang;
    if (!lang || lang === cfg.lang) return;
    load(lang).then(() => {
      const u = new URL(location.origin + location.pathname);
      u.searchParams.set('lang', lang);
      history.pushState({ lang }, '', u);
    });
  }, true);

  // Initial load
  const stored = localStorage.getItem('lang');
  const initial = new URLSearchParams(location.search).get('lang') || stored || cfg.lang;
  load(initial);
})();
